import { z } from 'zod'

const TaskSchema = z.object({
  task_id: z.number().nullable(),
  student_id: z.number().nullable(),
  student_first_name: z.string().nullable(),
  student_last_name: z.string().nullable(),
  student_grade: z.string().nullable(),
  submitted_at: z.string().nullable(),
  application_last_datetime: z.string().nullable(),
  application_flags_created_at: z.string().nullable(),
  days_since_submitted: z.number().nullable(),
  applicant_first_name: z.string().nullable(),
  applicant_last_name: z.string().nullable(),
  applicant_email: z.string().email().nullable(),
  global_application_flag_id: z.number().nullable(),
  application_flags_id: z.number().nullable(),
  global_application_code: z.string().nullable(),
  global_application_name: z.string().nullable(),
  scholarship_application_id: z.number().nullable(),
  category_name: z.string().nullable(),
  show_combinated_flags: z.array(z.string()).nullable().optional(),
  updated_notes: z.string().nullable(),
})

// Array of tasks
const TasksArraySchema = z.array(TaskSchema)

// Type inference
type Task = z.infer<typeof TaskSchema>
type Tasks = z.infer<typeof TasksArraySchema>

export { TaskSchema, TasksArraySchema, type Task, type Tasks }
